import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const loginUser = "Welcome, " + store.getters.givenName + " " + store.getters.familyName + "(" + store.getters.cognitoUserName +")";

const __returned__ = { loginUser }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})